import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Flame } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const fragment = (location.hash || window.location.hash || "").replace(/^#/, "");
    const params = new URLSearchParams(fragment);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        await refresh();
        toast.success(`Welcome, ${r.data.user.name || r.data.user.email}.`);
        navigate("/admin/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Authentication failed.";
        toast.error(typeof msg === "string" ? msg : "Authentication failed.");
        navigate("/admin/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-[#F6F0E6]">
      <div className="icon-badge !h-14 !w-14 mb-6">
        <Flame className="h-7 w-7 text-[#F28C18] animate-pulse" strokeWidth={1.5} />
      </div>
      <div className="overline">Authenticating</div>
      <div className="font-serif-display text-3xl mt-2">Lighting the altar…</div>
    </div>
  );
};

export default AuthCallback;
